export const GET_NEWS_FEED = 'GET_NEWS_FEED';
export const GET_NEWS_FEED_SUCCESS = 'GET_NEWS_FEED_SUCCESS';
export const GET_NEWS_FEED_ERROR = 'GET_NEWS_FEED_ERROR';

export const SAVE_FEED_SETTINGS = 'SAVE_FEED_SETTINGS';

export const REQUEST_RATING_NEWS = 'REQUEST_RATING_NEWS';
export const REQUEST_RATING_NEWS_FINISHED = 'REQUEST_RATING_NEWS_FINISHED';

export const GET_PREFERENCES = 'GET_PREFERENCES';
export const GET_PREFERENCES_FINISHED = 'GET_PREFERENCES_FINISHED';

export const SAVE_PREFERENCES = 'SAVE_PREFERENCES';
export const SAVE_PREFERENCES_FINISHED = 'SAVE_PREFERENCES_FINISHED';

export const getNewsFeedAction = ({ page, limit, settings, filters }) => ({
  type: GET_NEWS_FEED,
  payload: {
    type: 'DASHBOARD_NEWS',
    page,
    limit,
    settings,
    filters,
  },
});

export const saveFeedSettingsAction = ({ settings }) => ({
  type: SAVE_FEED_SETTINGS,
  payload: {
    settings,
  },
});

export const requestRatingNewsAction = ({ id, type }) => ({
  type: REQUEST_RATING_NEWS,
  payload: {
    id,
    type,
  },
});

export const getPreferencesAction = (defaultPrefs = false) => ({
  type: GET_PREFERENCES,
  payload: {
    defaultPrefs,
  },
});

export const savePreferencesAction = ({ emailNotifications, newsFeed, newsletter }) => ({
  type: SAVE_PREFERENCES,
  payload: {
    emailNotifications,
    newsFeed,
    newsletter,
  },
});
